var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"inline-block",class:{ 'animate-spin': _vm.spin },style:(_vm.svgStyle),attrs:{"viewBox":"0 0 24 24"}},[_c('path',{style:(_vm.pathStyle),attrs:{"d":_vm.icon}})])}
var staticRenderFns = []

export { render, staticRenderFns }